import eventBus from "../../../core/services/event-bus";
import ProductJSON from "./product-json";
import elementExists from "../../../core/utils/element-exists";
const ProductBackOrderNotice = ( element = '[product-back-order-notice]' ) => {
    const container = document.querySelector( element );
    if( elementExists( container ) ){
        let { currentVariant, productVariantInventory }  = ProductJSON();
        let inventory = {}
        let data = container.dataset;
        const validate = function(){
            getInventory();
            if( inventory != {} && 
                inventory.management != "" &&
                inventory.quantity < 1  && 
                inventory.policy == 'continue'){
                    if ( inventory.next_incoming_date != "" ){
                        container.innerHTML = data.dueInNotice.replace( '__DATE__' , inventory.next_incoming_date ) 
                    }else{
                        container.innerHTML = data.defaultNotice
                    }
                container.classList.remove('d-none');
            }else{
                container.innerHTML = ''
                container.classList.add('d-none');
            }
        }
        const getInventory = function(){
            inventory = {};
            inventory = productVariantInventory.find( ( item ) => {
                return item.id == currentVariant.id;
            });
            return inventory;
        }
        if( elementExists( container )){
            validate();
            eventBus.on( eventBus.types.OptionsSelected , function( e ){
                currentVariant = e.detail;
                validate();
            } ); 
        }
    }
}

export default ProductBackOrderNotice